import { render } from "./cloudflare_image_profile.vue?vue&type=template&id=2c6dfd8e&scoped=true"
import script from "./cloudflare_image_profile.vue?vue&type=script&lang=js"
export * from "./cloudflare_image_profile.vue?vue&type=script&lang=js"

import "./cloudflare_image_profile.vue?vue&type=style&index=0&id=2c6dfd8e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6dfd8e"]])

export default __exports__